<template>
    <div
        class="filter-dropdown"
        :class="extraClass"
        @click.prevent="toggle()"
        :data-filter-reference="filterData.reference"
        :data-selected-value="selectedReference"
    ><span class="truncate" v-html="filterData.title"></span></div>

    <div class="filter-dropdown-expanded">
        <div
            class="filter-dropdown"
            :class="extraClass.trim()"
            @click.prevent="toggle()"
        ><span class="truncate" v-html="filterData.defaultTitle ?? filterData.title"></span></div>
        <div class="filter-dropdown-body" ref="dropdown-body">
            <div
                class="filter-dropdown-item"
                :class="{ 'selected': item.selected, 'inactive': item.disabled }"
                v-for="(item, index) in filterData.items"
                @click.prevent="toggleSelect(item.reference)"
            >
                <span class="filter-dropdown-item-name" v-html="item.title"></span>
                <span class="filter-dropdown-item-count" v-html="item.count"></span>
            </div>
            <div
                v-if="filterData.enableClear && this.selectedReference"
                class="filter-dropdown-item clear"
                v-html="filterData.enableClearText"
                @click="toggleSelect(null)"
            ></div>
        </div>
    </div>
</template>

<script>

export default {

    name: "Dropdown",

    props: ['filter-data', 'class'],

    data() {
        return {
            isLoading: true,
            isActive: false,
            isDisabled: false,
            selectedReference: null,
            extraClass: null,
        }
    },

    created() {
        this.extraClass = this.class;

        if (this.filterData.hidden) {
            this.extraClass += '!hidden';
        }

        this.setSelectedItems();
    },

    mounted() {

        const referenceLoader = document.querySelector('[data-loader-reference="' + this.filterData.reference + '"]');

        if (referenceLoader) {
            referenceLoader.classList.add('opacity-0');
        }
    },

    methods: {
        toggle() {

            this.isActive = ! this.isActive;

            const referenceGroup = document.querySelector('[data-dropdown-reference="' + this.filterData.reference + '"]');

            if (referenceGroup) {
                referenceGroup.classList.toggle('active');
            }

            if (this.isActive) {
                document.addEventListener('click', this.closeOnClickOutside);
                this.activateItems();
            } else {
                document.removeEventListener('click', this.closeOnClickOutside);
                this.deactivateItems();
            }
        },

        activateItems() {
            const dropdownItems = this.$refs['dropdown-body'].querySelectorAll('.filter-dropdown-item');
            let index = 0;
            const interval = setInterval(() => {
                if (index < dropdownItems.length) {
                    dropdownItems[index].classList.add('active');
                    index++;
                } else {
                    clearInterval(interval);
                }
            }, 25);
        },

        deactivateItems() {
            const items = document.querySelectorAll('.filter-dropdown-item');
            items.forEach(item => {
                item.classList.remove('active');
            });
        },

        toggleSelect(reference) {

            this.selectedReference = (reference === this.selectedReference) ? null : reference;

            this.toggle();

            this.$nextTick(() => {
                this.Bus.emit('filter-change');
            })
        },

        setSelectedItems() {

            const values = Object.values(this.filterData.selectedFilters);
            let allKeys = [];

            values.forEach(innerObj => {
                const keys = Object.keys(innerObj);
                allKeys = allKeys.concat(keys);
            });

            this.selectedReference = allKeys.join(',');
        },

        hasSelectedItem() {
            return Object.values(this.filterData.selectedFilters).length > 0;
        },

        closeOnClickOutside(event) {
            if (
                event.target.classList.contains('filter-dropdown-group')
                && event.target.classList.contains('active')
            ) {
                this.toggle();
                document.removeEventListener('click', this.closeOnClickOutside);
            }
        }
    },

    computed: {

    },
}
</script>
